const defaultApiResponse = {
  code: 500000,
  data: null,
  meta: null,
}

export const useStoreArticleDetail = defineStore('articleDetail', () => {
  const nuxtApp = useNuxtApp()
  const kjdsConfig = useAppConfig().kijidas

  const state = reactive({
    initLoaded: false,
    relationsEventList: {},
    againRelationsList: [],
    againRelationsObj: [],
  })

  // todo: wyswigの画像を大きくする
  // setList(data) {
  //   const item = data.article
  //   if (item && !item.is_old && item.body_json) {
  //     //  一回parseして
  //     const json = JSON.parse(item.body_json)
  //     if (json.body && json.body.value) {
  //       //  置換して
  //       // wyswigの画像を大きくする
  //       json.body.value = json.body.value.replace(/<img src="(.+?)(\.[^.]+?)"/g, '<img src="$1_l$2"')
  //       item.body_json = JSON.stringify(json)
  //     }
  //   }
  //   this.item = item
  //   this.objects = data.article_objects
  // },
  function addRelationsEventList({ articleTypeSlug, list }) {
    const aNewList = {}
    aNewList[articleTypeSlug] = list
    state.relationsEventList = {
      ...state.relationsEventList,
      ...aNewList,
    }
    console.log('addRelationsEventList', list)
  }

  function clearRelationsEventList() {
    state.relationsEventList = {}
  }

  function addAgainRelationsList({ list, obj }) {
    state.againRelationsList = list
    state.againRelationsObj = obj
    console.log('addAgainRelationsList', list)
  }

  function clearAgainRelationsList() {
    state.againRelationsList = []
    state.againRelationsObj = []
  }

  //  キャッシュリストから、イベントを返す
  function getRelationsEventList(slug) {
    const item = state.relationsEventList[slug]
    if (item) {
      return item
    }
    return null
  }

  function getAgainRelationsList() {
    const item = state.againRelationsList
    return item
    // return state.againRelationsList
  }

  function getAgainRelationsObj() {
    const item = state.againRelationsObj
    return item
  }
  /**
     * 記事詳細取得(プレビュー対応)
     * options.fetchParamsを指定しない場合、useRouter.currentRouteから自動的に取得する
     * @param options
     * @returns
     */
  async function fetchDetail(options?: KjdsFetchDetailOptions): Promise<ApiResponse<ApiArticleDetail>> {
    const resData: ApiResponse<ApiArticleDetail> = { ...defaultApiResponse }
    let isPreviewMode = false
    let articleTypeSlug = ''
    let articleSlug = ''
    let articleId = 0

    if (options?.fetchParams?.articleTypeSlug) {
      articleTypeSlug = options.fetchParams.articleTypeSlug
    } else {
      const pageConfig = kjdsConfig.page[articleTypeSlug]
      if (!pageConfig) {
        console.error('## fetchDetail: no pageConfig')
        throw createError({
          statusCode: 902,
          statusMessage: 'Bad API Request',
          message: '記事詳細の取得パラメータがありません。',
          data: {},
          fatal: true,
        })
      }
      articleTypeSlug = pageConfig.articleTypeSlug
    }

    if (options?.fetchParams?.articleSlugOrId) {
      if (typeof options.fetchParams.articleSlugOrId === 'string') {
        articleSlug = options.fetchParams.articleSlugOrId
      } else if (typeof options.fetchParams.articleSlugOrId === 'number') {
        articleId = options.fetchParams.articleSlugOrId
        isPreviewMode = true
      }
    } else {
      const { currentRoute } = useRouter()
      const routeName = currentRoute.value.name as string
      isPreviewMode = routeName.includes('preview') && routeName.includes('slug')
      const routeParams = currentRoute.value.params
      if (isPreviewMode) {
        articleId = Number(routeParams.slug)
      } else {
        articleSlug = routeParams.slug as string
      }
    }

    if (!((articleId || articleSlug) && articleTypeSlug)) {
      console.error('## fetchDetail: error: no articleId / articleSlug / articleTypeSlug')
      throw createError({
        statusCode: 911,
        statusMessage: 'Bad API Request',
        message: '記事の取得パラメータがありません。',
        data: {},
        fatal: true,
      })
    }

    let response
    let statusCode = 200
    if (articleId) {
      // IDモード
      try {
        // IDモードはキャッシュしない
        response = await nuxtApp.$ArticleApi.articleDetailId(
          articleId,
          articleTypeSlug,
        )
      } catch (e) {
        return resData
      }
    } else {
      // Slugモード
      const reqParams = {
        slug: articleSlug,
        articleTypeSlug,
      }
      try {
        if (kjdsConfig.maxCacheSize) {
          const cacheKeyName = options?.cache?.key || JSON.stringify({
            name: 'articleDetail',
            reqParams,
          })
          response = await nuxtApp.$ApiWithCache(
            () => nuxtApp.$ArticleApi.articleDetailSlug(reqParams.slug, reqParams.articleTypeSlug),
            { key: cacheKeyName },
          )
        } else {
          response = await nuxtApp.$ArticleApi.articleDetailSlug(reqParams.slug, reqParams.articleTypeSlug)
        }
      } catch (e) {
        statusCode = e.response.status || 500
      }
    }

    let error = null

    if (statusCode === 404) {
      return {
        ...resData,
        code: 404000,
      }
    } else if (statusCode !== 200) {
      error = createError({
        statusCode: 913,
        fatal: true,
      })
    }

    if (error) {
      if (!options?.isNoThrowError) {
        showError(error)
      }
      return resData
    }

    return {
      ...resData,
      ...response.data,
    }
  }

  return {
    state,
    addRelationsEventList,
    clearRelationsEventList,
    addAgainRelationsList,
    clearAgainRelationsList,
    getRelationsEventList,
    getAgainRelationsList,
    getAgainRelationsObj,
    fetchDetail,
  }
})
